import { Routes } from '@angular/router';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { UsersComponent } from './users.component';
var ɵ0 = { title: 'CORE.SERVICES.NAVIGATION.SETTINGS.USERS' };
var routes = [
    {
        path: 'usuarios',
        component: UsersComponent,
        canActivate: [
            AuthenticatedGuard,
        ],
        data: ɵ0
    }
];
var UsersModule = /** @class */ (function () {
    function UsersModule() {
    }
    return UsersModule;
}());
export { UsersModule };
export { ɵ0 };
